import { useTranslation } from 'react-i18next';

import SaveAsIcon from '~/assets/icons/modal/save.svg?react';
import { ConfirmPopup } from '~/components/atoms/ConfirmPopup';
import { COLORS } from '~/styles/colors';

type ConfirmLeaveEditingQrProps = {
  onAccept: () => void;
  onClose: () => void;
  isOpen?: boolean;
};

export const ConfirmLeaveEditingQr = ({ onAccept, onClose, isOpen }: ConfirmLeaveEditingQrProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmPopup
      open={isOpen}
      title={t('popup:leaveWithoutSaving')}
      subTitle={t('popup:youHaveUnsavedChanges')}
      textBtn1={t('popup:stayOnPage')}
      textBtn2={t('popup:leaveAnyway')}
      icon={<SaveAsIcon sx={{ width: 60, height: 60 }} />}
      btnColor2={COLORS.purple}
      onAccept={onAccept}
      onClose={onClose}
    />
  );
};
